import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReceiveWaitingCollection {
  collectionId: number
  collectionNo: string
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  forwardingBranchCode: SystemCode
  collectionFlag: CollectionFlag
}

export function ReceiveWaitingCollectionFromJSON(
  json: any
): ReceiveWaitingCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: json.bibliography_class,
    prefix: json.prefix,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
